module.exports = __webpack_public_path__ + "static/img/card_01.b6e517fc.jpg";